// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.abL8bkTRJl_hjhpwjqwu {
    list-style: none;
    box-sizing: border-box;
    padding-left: var(--spacing);
    margin-bottom: -1px;
  
    &.OYsALCg2aKQCg1baT_WO {
      display: inline-block;
      pointer-events: none;
      padding: 0;
      margin-left: 10px;
      margin-top: 5px;
  
      .c2pbVGG8owmWqiKlzJ9i {
        --vertical-padding: 5px;
  
        padding-right: 24px;
        border-radius: 4px;
        box-shadow: 0px 15px 15px 0 rgba(34, 33, 81, 0.1);
      }
    }
  
    &.tVSx8WAguSnoZ41v1NAs {
      &.zPaqrQXoXr_w1R0E9aNA {
        opacity: 1;
        position: relative;
        z-index: 1;
        margin-bottom: -1px;
  
        .c2pbVGG8owmWqiKlzJ9i {
          position: relative;
          padding: 0;
          height: 8px;
          border-color: #2389ff;
          background-color: #56a1f8;
  
          &:before {
            position: absolute;
            left: -8px;
            top: -4px;
            display: block;
            content: '';
            width: 12px;
            height: 12px;
            border-radius: 50%;
            border: 1px solid #2389ff;
            background-color: #ffffff;
          }
  
          > * {
            /* Items are hidden using height and opacity to retain focus */
            opacity: 0;
            height: 0;
          }
        }
      }
  
      &:not(.zPaqrQXoXr_w1R0E9aNA) {
        opacity: 0.5;
      }
  
      .c2pbVGG8owmWqiKlzJ9i > * {
        box-shadow: none;
        background-color: transparent;
      } 
    }

    &.oMYwSJztmJ4m623ImXPA {
      opacity: 1;
      position: relative;
      z-index: 1;
      margin-bottom: -1px;

      .c2pbVGG8owmWqiKlzJ9i {
        position: relative;
        padding: 0;
        height: 8px;
        border-color: darkgrey;
        background-color: darkgrey;

        &:before {
          position: absolute;
          left: -8px;
          top: -4px;
          display: block;
          content: '';
          width: 12px;
          height: 12px;
          border-radius: 50%;
          border: 1px solid  darkgrey;
          background-color: #ffffff;
        }

        > * {
          /* Items are hidden using height and opacity to retain focus */
          opacity: 0;
          height: 0;
        }
      }
    }
  }
  
  .c2pbVGG8owmWqiKlzJ9i {
    --vertical-padding: 10px;
  
    position: relative;
    display: flex;
    align-items: center;
    padding: var(--vertical-padding) 10px;
    background-color: #fff;
    border: 1px solid #dedede;
    color: #222;
    box-sizing: border-box;
  }
  
  .a2EoirGUafwIQbkNENe7 {
    flex-grow: 1;
    padding-left: 0.5rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  
  .BJQW3c9QXZ8_v3TDe5BQ {
    position: absolute;
    top: -10px;
    right: -10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #2389ff;
    font-size: 0.8rem;
    font-weight: 600;
    color: #fff;
  }
  
  .NBWFjav1WijNQQJWIz_R {
    pointer-events: none;
  }
  
  .K4D86T64BpuoCsS_AsXH,
  .OYsALCg2aKQCg1baT_WO {
    .a2EoirGUafwIQbkNENe7,
    .BJQW3c9QXZ8_v3TDe5BQ {
      user-select: none;
      -webkit-user-select: none;
    }
  }
  
  .uHbUJ1flXjxL2zbuIKdx {
    svg {
      transition: transform 250ms ease;
    }
  
    &.Bh3NAkySbOHohsDq0MdE svg {
      transform: rotate(-90deg);
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/sortableTree.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;IAC5B,mBAAmB;;IAEnB;MACE,qBAAqB;MACrB,oBAAoB;MACpB,UAAU;MACV,iBAAiB;MACjB,eAAe;;MAEf;QACE,uBAAuB;;QAEvB,mBAAmB;QACnB,kBAAkB;QAClB,iDAAiD;MACnD;IACF;;IAEA;MACE;QACE,UAAU;QACV,kBAAkB;QAClB,UAAU;QACV,mBAAmB;;QAEnB;UACE,kBAAkB;UAClB,UAAU;UACV,WAAW;UACX,qBAAqB;UACrB,yBAAyB;;UAEzB;YACE,kBAAkB;YAClB,UAAU;YACV,SAAS;YACT,cAAc;YACd,WAAW;YACX,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,yBAAyB;YACzB,yBAAyB;UAC3B;;UAEA;YACE,8DAA8D;YAC9D,UAAU;YACV,SAAS;UACX;QACF;MACF;;MAEA;QACE,YAAY;MACd;;MAEA;QACE,gBAAgB;QAChB,6BAA6B;MAC/B;IACF;;IAEA;MACE,UAAU;MACV,kBAAkB;MAClB,UAAU;MACV,mBAAmB;;MAEnB;QACE,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,sBAAsB;QACtB,0BAA0B;;QAE1B;UACE,kBAAkB;UAClB,UAAU;UACV,SAAS;UACT,cAAc;UACd,WAAW;UACX,WAAW;UACX,YAAY;UACZ,kBAAkB;UAClB,2BAA2B;UAC3B,yBAAyB;QAC3B;;QAEA;UACE,8DAA8D;UAC9D,UAAU;UACV,SAAS;QACX;MACF;IACF;EACF;;EAEA;IACE,wBAAwB;;IAExB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE;;MAEE,iBAAiB;MACjB,yBAAyB;IAC3B;EACF;;EAEA;IACE;MACE,gCAAgC;IAClC;;IAEA;MACE,yBAAyB;IAC3B;EACF","sourcesContent":[".Wrapper {\n    list-style: none;\n    box-sizing: border-box;\n    padding-left: var(--spacing);\n    margin-bottom: -1px;\n  \n    &.clone {\n      display: inline-block;\n      pointer-events: none;\n      padding: 0;\n      margin-left: 10px;\n      margin-top: 5px;\n  \n      .TreeItem {\n        --vertical-padding: 5px;\n  \n        padding-right: 24px;\n        border-radius: 4px;\n        box-shadow: 0px 15px 15px 0 rgba(34, 33, 81, 0.1);\n      }\n    }\n  \n    &.ghost {\n      &.indicator {\n        opacity: 1;\n        position: relative;\n        z-index: 1;\n        margin-bottom: -1px;\n  \n        .TreeItem {\n          position: relative;\n          padding: 0;\n          height: 8px;\n          border-color: #2389ff;\n          background-color: #56a1f8;\n  \n          &:before {\n            position: absolute;\n            left: -8px;\n            top: -4px;\n            display: block;\n            content: '';\n            width: 12px;\n            height: 12px;\n            border-radius: 50%;\n            border: 1px solid #2389ff;\n            background-color: #ffffff;\n          }\n  \n          > * {\n            /* Items are hidden using height and opacity to retain focus */\n            opacity: 0;\n            height: 0;\n          }\n        }\n      }\n  \n      &:not(.indicator) {\n        opacity: 0.5;\n      }\n  \n      .TreeItem > * {\n        box-shadow: none;\n        background-color: transparent;\n      } \n    }\n\n    &.indicatorDisabled {\n      opacity: 1;\n      position: relative;\n      z-index: 1;\n      margin-bottom: -1px;\n\n      .TreeItem {\n        position: relative;\n        padding: 0;\n        height: 8px;\n        border-color: darkgrey;\n        background-color: darkgrey;\n\n        &:before {\n          position: absolute;\n          left: -8px;\n          top: -4px;\n          display: block;\n          content: '';\n          width: 12px;\n          height: 12px;\n          border-radius: 50%;\n          border: 1px solid  darkgrey;\n          background-color: #ffffff;\n        }\n\n        > * {\n          /* Items are hidden using height and opacity to retain focus */\n          opacity: 0;\n          height: 0;\n        }\n      }\n    }\n  }\n  \n  .TreeItem {\n    --vertical-padding: 10px;\n  \n    position: relative;\n    display: flex;\n    align-items: center;\n    padding: var(--vertical-padding) 10px;\n    background-color: #fff;\n    border: 1px solid #dedede;\n    color: #222;\n    box-sizing: border-box;\n  }\n  \n  .Text {\n    flex-grow: 1;\n    padding-left: 0.5rem;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n  \n  .Count {\n    position: absolute;\n    top: -10px;\n    right: -10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background-color: #2389ff;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: #fff;\n  }\n  \n  .disableInteraction {\n    pointer-events: none;\n  }\n  \n  .disableSelection,\n  .clone {\n    .Text,\n    .Count {\n      user-select: none;\n      -webkit-user-select: none;\n    }\n  }\n  \n  .Collapse {\n    svg {\n      transition: transform 250ms ease;\n    }\n  \n    &.collapsed svg {\n      transform: rotate(-90deg);\n    }\n  }"],"sourceRoot":""}]);
// Exports
export var Wrapper = `abL8bkTRJl_hjhpwjqwu`;
export var clone = `OYsALCg2aKQCg1baT_WO`;
export var TreeItem = `c2pbVGG8owmWqiKlzJ9i`;
export var ghost = `tVSx8WAguSnoZ41v1NAs`;
export var indicator = `zPaqrQXoXr_w1R0E9aNA`;
export var indicatorDisabled = `oMYwSJztmJ4m623ImXPA`;
export var Text = `a2EoirGUafwIQbkNENe7`;
export var Count = `BJQW3c9QXZ8_v3TDe5BQ`;
export var disableInteraction = `NBWFjav1WijNQQJWIz_R`;
export var disableSelection = `K4D86T64BpuoCsS_AsXH`;
export var Collapse = `uHbUJ1flXjxL2zbuIKdx`;
export var collapsed = `Bh3NAkySbOHohsDq0MdE`;
export default ___CSS_LOADER_EXPORT___;
